export interface IProps {
    productId: string;
    onClose: () => void;
    onSuccess?: () => void;
    type: EPaymentModalType;
}

export enum EPaymentModalType {
    trial = 'trial',
    fastcheckout = 'fastcheckout',
}
